export default {"src":"/_next/static/media/NT-card-number-post-01-nov-2020.f1882fd9.svg","height":142,"width":222,"blurWidth":0,"blurHeight":0};